export default "https://cdn-static.gokick.com/assets/6ff5832d0d355fee068eb0a1603b37a2d61221c6/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";